import { formatPhone } from '@webapp/common/components/textfield/lib';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class PhoneApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: answersActors.map((answerActor) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { extra, value } = response.getSnapshot().context;
                return {
                    answer: parseInt(String(id)),
                    text: String(value),
                    longtext: extra as string,
                    bool: true,
                };
            }),
            comment,
        };
    }

    public validate({ answersActors, params }: QuestionContext): boolean {
        const { phoneFormatCountry, phoneFormatNumber, required } = params;

        if (!required) {
            return true;
        }

        const mask = (phoneFormatCountry + ' ' + phoneFormatNumber).replace(/_/g, '');
        const maskLen = mask.length;

        const withValueCount = answersActors.reduce((acc, answerActor) => {
            const { response } = answerActor.getSnapshot().context;
            const { extra, value } = response.getSnapshot().context;
            const fullValue = (extra as string) + ' ' + (value as string);
            const formatted = formatPhone(fullValue || '', phoneFormatCountry, phoneFormatNumber);
            const match = formatted.length === maskLen;

            return acc + Number(match);
        }, 0);

        return withValueCount === answersActors.length;
    }
}
